import { render, staticRenderFns } from "./ReturnArchiveModal3.vue?vue&type=template&id=33f00fa1&"
import script from "./ReturnArchiveModal3.vue?vue&type=script&lang=js&"
export * from "./ReturnArchiveModal3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnArchiveModal3.vue"
export default component.exports